// extracted by mini-css-extract-plugin
export default {"Description":"description_Description__qTyyn","PopoverMenuContent":"description_PopoverMenuContent__paD7y","PopoverItemContent":"description_PopoverItemContent__UgiMd"};